// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"67845e44","522":"c5c4eb86","980":"17b5598b"}[chunkId] + ".js";
};